import { useEffect } from 'react';

const SESSION_KEY = 'bharatdesk_session_active';

/** Marks session as active — data lives on backend disk, not in browser storage. */
export function useSessionKeepAlive() {
  useEffect(() => {
    try {
      sessionStorage.setItem(SESSION_KEY, String(Date.now()));
    } catch (e) {
      /* private mode or blocked storage */
    }
  }, []);
}

export function SessionBanner() {
  return (
    <div className="session-banner">
      💾 डेटा सुरक्षित — सभी ट्रेड backend पर disk में सेव होते हैं। Browser बंद करें, session clear न करें; पुराना tab खोलें।
    </div>
  );
}
